/* eslint-disable no-unused-vars */
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, Route, Routes, useNavigate, Navigate } from 'react-router-dom';
import ResponsiveAppBar from 'components/common/responsiveAppBar/ResponsiveAppBar';
import { useEffect } from 'react';
import { routes } from 'config';
import { LoginRedirect } from './loginPages/LoginRedirect';

const link = routes.list.find((route) => route.id === 'dashboard');

const ViewsLayout = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (window.location.pathname === '/') {
  //     console.log('navigate to: ', link.url);
  //     navigate(link.url);
  //   }
  // }, [dispatch]);

  return (
    <>
      <ResponsiveAppBar title={t('header.title')} />
      <Outlet />
      <Routes>
        <Route path='/' element={<LoginRedirect />} />
        {routes.list.map((route) => {
          return (
            <Route
              key={route.id}
              path={route.url}
              //element={route.element}
              element={
                <ProtectedRoute
                  element={route.element}
                  allowedRoles={route.availableForRoles}
                  redirectTo={route.redirectTo}
                  redirectToSamsung={route.redirectToSamsung}
                />
              }
              caseSensitive={route.caseSensitive}
            />
          );
        })}
        {/* default */}
        <Route path='*' element={routes.notFound.component} />
      </Routes>
    </>
  );
};

export default ViewsLayout;

const hasIntersection = (array1, array2) => {
  if (!array1.length) return true;
  const set1 = new Set(array1);
  return array2.some((item) => set1.has(item));
};

const ProtectedRoute = ({ element, allowedRoles, redirectTo, redirectToSamsung }) => {
  const userRole = useSelector((state) => state.auth.pb_roles);
  const isSamsungUser = useSelector((state) => state.auth.isSamsungUser);

  if (redirectToSamsung && isSamsungUser) return <Navigate to={redirectToSamsung} replace />;

  const isAuthorized = !allowedRoles || hasIntersection(userRole, allowedRoles);
  return isAuthorized ? element : <Navigate to={redirectTo ? redirectTo : '/'} replace />;
};
